import script from "./ModalAiSetupNameSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAiSetupNameSection.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAiSetupNameSection.vue?vue&type=style&index=0&id=32a539d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a539d4"]])

export default __exports__